export enum TrimType {
  Frame = 'frame',
  Time = 'time'
}

export default TrimType;
